export default __webpack_public_path__ + "static/media/borzo.6bb36763.svg";